import React from 'react'

import './HistoriqueItem.scss'
import {HistoriqueOrderModel} from "../../Models/HistoriqueOrderModel";

interface MenuItemProps {
    order: HistoriqueOrderModel
    onClick: () => void
}

const HistoriqueItem: React.FC<MenuItemProps> = ({order, onClick}: MenuItemProps) => {

    return (
        <div className="historiqueItem">
            {
                order && (
                    <>
                        <div className="historiqueItem__cadre">
                            <img
                                src={order.image}
                                alt="item"
                            />
                        </div>
                        <div className="historiqueItem__infos">
                            <div className="historiqueItem__infos__top">
                                <p className="historiqueItem__infos__top--name">#{order.reference}</p>
                                <p className="historiqueItem__infos__top--price">{order.priceTTC} €</p>
                            </div>
                            <p className="historiqueItem__infos--porte">{order.pdvName} <span onClick={onClick}>Voir QR code</span></p>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default HistoriqueItem;
